module.exports = __webpack_public_path__ + "01f43047/img/document.e2130c6b.svg";